import { render, staticRenderFns } from "./ConsejoSection.vue?vue&type=template&id=9fc4d7b6&scoped=true&"
import script from "./ConsejoSection.vue?vue&type=script&lang=js&"
export * from "./ConsejoSection.vue?vue&type=script&lang=js&"
import style0 from "./ConsejoSection.vue?vue&type=style&index=0&id=9fc4d7b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc4d7b6",
  null
  
)

export default component.exports